/**
 * Copyright 2016-2021 Sourcepole AG
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import SideBar from 'qwc2/components/SideBar';
import LocaleUtils from "qwc2/utils/LocaleUtils";
import AppStateUtils from "../utils/AppStateUtils";

class Contact extends React.Component {
    static propTypes = {
        currentTask: PropTypes.object,
        email: PropTypes.string,
        side: PropTypes.string,
        state: PropTypes.object,
        width: PropTypes.string
    }
    static defaultProps = {
        width: "25em",
        side: 'right'
    }
    state = {
        email: "",
        sidebarwidth: null
    }

    openMail(response) {
        let url = window.location.href;
        if (response !== null) {
            const path = window.location.href.split('?')[0];
            url = path.replace(/\/$/, '') + '/?k=' + response.data.id;
        }
        window.location = 'mailto:' + this.props.email + "?body=" + encodeURIComponent(url);
    }

    sendMsg()  {
        const self = this;
        AppStateUtils.generatePermaLink(this.props.state, (url) => {
            self.openMail(url);
        });
    }

    render() {
        let content = (
            <div style={{padding: '20px'}}>
                <button className="button"
                        onClick={() => this.sendMsg()}>{LocaleUtils.tr("appmenu.items.Contact")}</button>
            </div>
        );

        return (
            <div>
                <SideBar icon="envelope" id="Contact"
                         side={this.props.side}
                         title={LocaleUtils.tr("appmenu.items.Contact")} width={this.state.sidebarwidth || this.props.width}>
                    {() => ({
                        body: (
                            <div>
                                {content}
                            </div>
                        )
                    })}
                </SideBar>
            </div>
        );
    }
}

const selector = (state) => ({
    state
});

export default connect(selector, {

})(Contact);
